module.exports = __webpack_public_path__ + "media/images/gift1-86262b3f9a7331c80d7750ce90a8c999.jpg";